import { createI18n } from 'vue-i18n'
import zh from './zh.json'
import en from './en.json'

const defaultLocale = localStorage.getItem('CodiggerLanguage') || 'zh';
const i18n = createI18n({
    'legacy': false,
    'locale': defaultLocale,
    'fallbackLocale': 'zh',
    'messages': {
        en,
        zh,
    }
})

export default i18n
